import { skipToken } from "@reduxjs/toolkit/query"
import { GetCreditHistoryRes } from "gen/api/billpayment/service_pb"
import {
  mapFields,
  mapFieldsArray,
  useQueryAdapter,
} from "shared-ts/adapters/useQueryAdapter"
import { UUID } from "shared-ts/classes/uuid"
import { BaseReceivable, getReceivableMapping } from "shared-ts/receivables"

import { useGetCreditHistoryQuery } from "features/api/bill"

import {
  ReceivableHistoryItem,
  receivableHistoryMapping,
} from "../../ReceivableHistory/receivableHistory.adapter"

interface ReceivableHistory {
  receivable: BaseReceivable
  notes: string
  historyItems: ReceivableHistoryItem[]
}

export function useReceivableHistoryData(leID: UUID | undefined) {
  const getReceivableHistoryQuery = useGetCreditHistoryQuery(
    leID ? { id: leID } : skipToken
  )
  const receivableHistoryData = useQueryAdapter({
    query: getReceivableHistoryQuery,
    adapter: adaptReceivableHistory,
    defaultValue: undefined,
  })
  return {
    data: receivableHistoryData.data,
    isLoading: getReceivableHistoryQuery.isLoading,
    isError: getReceivableHistoryQuery.isError,
  }
}

const adaptReceivableHistory = (
  res: GetCreditHistoryRes
): ReceivableHistory => {
  const { data, errors } = mapFields(res, getReceivableMapping())
  if (errors) throw new Error("Error mapping receivable history")
  const historyItems = mapFieldsArray(
    res.receivableHistory,
    receivableHistoryMapping
  )
  return {
    receivable: data,
    notes: res.notes ?? "",
    historyItems,
  }
}
